import { ExpiredSessionError, ResponseError } from "src/utils";
import api from "./webapp";

export default class EmployeeApi {
  static async checkPin(employeeId: number, pin: string) {
    try {
      const { data } = await api.get(`/colaborador/check-pin/${employeeId}`, { params: pin });
      return data;
    } catch (error) {
      if (error instanceof ExpiredSessionError) {
        throw error;
      } else {
        throw new ResponseError(error);
      }
    }
  }
}
